import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Create from "./pages/Create";
import Explore from "./pages/Explore";
import ProjectDetail from "./pages/ProjectDetail"
import MyNFT from "./pages/MyNFT";
import NFTDetail from "./pages/NFTDetail";
import AboutUs from "./pages/AboutUs";

import { WagmiConfig } from "wagmi";
import { ConnectKitProvider } from "connectkit";
import client from "./lib/wagmi";
import ErrorBoundary from "./components/ErrorBoundary";
import { CHAIN_IDS } from "./constants/Contracts";

// Suppress Coinbase Wallet WebSocket errors (error 1006 is non-critical)
if (typeof window !== 'undefined') {
  const originalError = console.error;
  console.error = (...args) => {
    const errorString = args.join(' ');
    if (
      errorString.includes('websocket error 1006') ||
      errorString.includes('RxWebSocket') ||
      (errorString.includes('coinbase') && errorString.includes('websocket'))
    ) {
      // Suppress Coinbase Wallet connection errors - these are non-critical
      // Error 1006 occurs when Coinbase Wallet extension is not installed
      return;
    }
    originalError.apply(console, args);
  };
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <WagmiConfig client={client}>
        <ConnectKitProvider theme="auto" mode="light" options={{ initialChainId: CHAIN_IDS.GOERLI }}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/create" element={<Create />} />
              <Route path="/explore" element={<Explore />} />
              <Route path="/detail/:projectId?" element={<NFTDetail />} />
              <Route path="/projectdetail" element={<ProjectDetail />} />
              <Route path="/myartblock" element={<MyNFT />} />
              <Route path="/about" element={<AboutUs />} />
            </Routes>
          </BrowserRouter>
        </ConnectKitProvider>
    </WagmiConfig>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
